import { QA_ATTRIBUTE } from '../constants/qaAttributes';

export default (qaLabel?: string) =>
  qaLabel
    ? {
        [QA_ATTRIBUTE]: qaLabel,
      }
    : {};
